import Box from '@mui/material/Box';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomDataGrid } from '../data-grid/CustomDataGrid';
import { Utils } from '@hellohair/types';
import { useStyles } from '../../theme/styles.helpers';
import { CustomersStyles } from './Customers.Styles';
import { Typography } from '@mui/material';
import { DataContext } from '../../aws/DataProvider';

interface ListRow {
  status: string;
  customerId: string;
  current_period_end: string;
  created: string;
  paused: string;
  customerEmail: string;
  product: string;
  isMedical: string;
}

const OldSubscriptions = ({ search }: { search: string }) => {
  const styles = useStyles(CustomersStyles, {});
  const { t } = useTranslation();
  const [rows, setRows] = useState<ListRow[]>();
  const {
    oldSubscriptionsState: [allSubscriptions],
  } = useContext(DataContext);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const transformToRow = (request: Utils.DBItem<any>) => {
    return {
      status: request.status === 'active' ? t('Active') : request.status,
      created: new Date(request.created * 1000).toLocaleString('de-DE'),
      current_period_end: new Date(request.current_period_end * 1000).toLocaleString('de-DE'),
      paused: request.paused ? t('Yes') : t('No'),
      customerEmail: request.customerEmail,
      product: request.product,
      isMedical: request.isMedical ? t('Yes') : t('No'),
      customerId: request.customerId,
    };
  };

  useEffect(() => {
    setRows(allSubscriptions.map(transformToRow));
  }, [allSubscriptions]);

  useEffect(() => {
    const _rows = allSubscriptions.map(transformToRow).filter((row) => {
      return Object.values(row).some((value) => {
        if (typeof value === 'string') {
          return value.toLowerCase().includes(search.toLowerCase());
        }
        return false;
      });
    });
    setRows(_rows);
  }, [search]);

  const columns = [
    { field: 'customerEmail', headerName: t('E-Mail'), filterable: false, flex: 1 },
    { field: 'status', headerName: t('Status'), filterable: false },
    { field: 'paused', headerName: t('Paused'), filterable: false },
    { field: 'isMedical', headerName: t('Medical'), filterable: false },
    { field: 'created', headerName: t('Created'), filterable: false, flex: 1 },
    { field: 'current_period_end', headerName: t('Current cycle end'), filterable: false, flex: 1 },
    { field: 'product', headerName: t('Product'), filterable: false, flex: 1 },
  ];

  const totalSubs = allSubscriptions.length;
  const totalMedical = allSubscriptions.filter((s) => s.isMedical).length;
  const totalPaused = allSubscriptions.filter((s) => s.paused).length;
  const totalPausedMedical = allSubscriptions.filter((s) => s.paused && s.isMedical).length;

  return (
    <Box sx={styles.root}>
      <CustomDataGrid
        columns={columns}
        rows={rows || []}
        getRowId={(row) => row.customerId + row.created}
        isCellEditable={() => false}
        isRowSelectable={() => false}
        pagination
        autoPageSize
        sx={styles.row}
        ignoreDiacritics
        initialState={{
          sorting: {
            sortModel: [{ field: 'created', sort: 'desc' }],
          },
        }}
      />
      <Box paddingX={7} display={'flex'} gap={2} alignItems={'center'} justifyContent={'end'}>
        <Typography>
          {t('Total')}: {totalSubs} ({totalMedical} {t('Medical')})
        </Typography>
        <Typography>
          {t('Active')}: {totalSubs - totalPaused} ({totalMedical - totalPausedMedical} {t('Medical')})
        </Typography>
        <Typography>
          {t('Paused')}: {totalPaused} ({totalPausedMedical} {t('Medical')})
        </Typography>
      </Box>
    </Box>
  );
};

export default OldSubscriptions;
